import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core'
import { useTranslation } from '../../contexts/i18n/use'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { ConfirmationItem } from '../forms_page/confirmationitem'

export const CheckinModal = ({data, cancelcallback, confirmcallback}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { actions: {t}} = useTranslation();

  return (
    <Dialog 
      open={true} 
      classes={{paper: classes.modal}}
      className="checkinpage-modal-root"
      >
      <DialogTitle>{ t('checkinpage.modal.title')}</DialogTitle>
      <DialogContent id="checkinpage-modal-content">
        { data ? <ConfirmationItem head={t('checkinpage.formlabel')} body={data} />: <span/>}
      </DialogContent>
      <DialogActions className={classes.buttonwrapper}>
        <Button className={[classes.cancelbutton, "dialogbutton"].join(' ')} id="checkinpage-modal-decline-button" onClick={x => cancelcallback()}>
          <Typography id="checkinpage-modal-decline-button-text">
            { t('checkinpage.modal.cancel')}
          </Typography>
        </Button>
        <Button className={[classes.confirmbutton, "dialogbutton"].join(' ')} id="checkinpage-modal-confirm-button" onClick={x => confirmcallback()}>
          <Typography id="checkinpage-modal-confirm-button-text">
            { t('checkinpage.modal.confirm')}
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const useStyles = makeStyles({
  modal: theme => ({
    border: '1px solid '+ theme.palette.primary.main,
    alignItems: 'center'
  }),
  buttonwrapper: {
    display: 'flex',
    flexDirection: 'row',
    padding: '1rem 0',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '80%'
  },
  confirmbutton: theme => ({
    backgroundColor: theme.palette.error.main,
    color: theme.palette.button_text.main,
    [theme.breakpoints.up('lg')]: {
      '&:hover': {
        backgroundColor: 'black',
        color: 'white'
      }
    },
    [theme.breakpoints.down('lg')]: {
      '&:hover': {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.button_text.main
      }
    }
  }),
  cancelbutton: theme => ({
    backgroundColor: theme.palette.info.main,
    color: theme.palette.button_text.main,
    [theme.breakpoints.up('lg')]: {
      '&:hover': {
        backgroundColor: 'black',
        color: 'white'
      }
    },
    [theme.breakpoints.down('lg')]: {
      '&:hover': {
        backgroundColor: theme.palette.info.main,
        color: theme.palette.button_text.main
      }
    }
  })
})